import EventDetailLayout from '@/layouts/EventDetail';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function PrivateTabsEventEventIdLayoutRoute() {
  return <EventDetailLayout basePath="/event" />;
}
